import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { cardStyle } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	finishForm: {
		...THEME.common.scrollBar,
		maxHeight: '60vh',
		minHeight: 0,
		overflowY: 'auto',
	},
	// The sidebar's own chrome. Only one host wrapped this in cardStyle, so on every other surface it
	// drew a harder border than the cards beside it.
	card: {
		...cardStyle,
		boxSizing: 'border-box',
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
	},
	title: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
	},
	detail: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	metaRow: {
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.xs,
	},
	metaLabel: {
		color: THEME.colors.text.light,
	},
	metaValue: {
		color: THEME.colors.text.main,
	},
	explanation: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: 1.5,
		marginTop: THEME.spacing.xs,
	},
	actionButton: {
		alignSelf: 'flex-start',
		marginTop: THEME.spacing.xs,
	},
	annotations: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	annotationLink: {
		alignSelf: 'flex-start',
	},
});
